import type { RouteObject } from 'react-router-dom'
import { useRoutes } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Layout from '@/components/Layout'
import Home from '@/pages/Home'
import Calculator from '@/pages/Calculator'
import Blog from '@/pages/Blog'
import About from '@/pages/About'

export const routes: RouteObject[] = [
  { path: '/', element: <Layout><Home /></Layout> },
  { path: '/calculator', element: <Layout><Calculator /></Layout> },
  { path: '/blog', element: <Layout><Blog /></Layout> },
  { path: '/about', element: <Layout><About /></Layout> },
]

function App() {
  const element = useRoutes(routes)
  return (
    <>
      {element}
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            color: '#FAFAF7',
            border: '2px solid #0A0A0A',
            borderRadius: 0,
            fontSize: 13,
            fontWeight: 500,
            letterSpacing: '-0.01em',
          },
        }}
      />
    </>
  )
}

export default App
